module.exports = __webpack_public_path__ + "static/car-346cefd62bee18ba837cfefc658693d1.svg";